
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dodaj-ogloszenie/sprzedaj/samochod-dostawczy",
      function () {
        return require("private-next-pages/dodaj-ogloszenie/sprzedaj/samochod-dostawczy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dodaj-ogloszenie/sprzedaj/samochod-dostawczy"])
      });
    }
  